import { RELATIONSHIP_TYPE } from "../consts";

/**
 * Filters entities by relationship type and extracts groups with valid id and name
 * @param {Array} appliedEntities - Array of applied entity objects
 * @param {string} relationshipType - The relationship type to filter by ("direct" or "indirect")
 * @returns {Array} Array of group objects with valid id and name
 */
export const getTeamsByRelationshipType = (
  appliedEntities,
  relationshipType
) => {
  if (!appliedEntities || !Array.isArray(appliedEntities)) {
    return [];
  }

  return appliedEntities
    .filter(
      (entity) =>
        entity.relationshipType === relationshipType &&
        entity.group?.id &&
        entity.group?.name
    )
    .map((entity) => entity.group);
};

/**
 * Gets direct teams from appliedEntities
 * @param {Array} appliedEntities - Array of applied entity objects
 * @returns {Array} Array of direct team group objects
 */
export const getDirectTeams = (appliedEntities) => {
  return getTeamsByRelationshipType(appliedEntities, RELATIONSHIP_TYPE.DIRECT);
};

/**
 * Gets indirect teams from appliedEntities
 * @param {Array} appliedEntities - Array of applied entity objects
 * @returns {Array} Array of indirect team group objects
 */
export const getIndirectTeams = (appliedEntities) => {
  return getTeamsByRelationshipType(
    appliedEntities,
    RELATIONSHIP_TYPE.INDIRECT
  );
};
